module.exports = __webpack_public_path__ + "static/media/Catamaran-Regular.59bbd724.ttf";